import { render, staticRenderFns } from "./ShippingAddress.vue?vue&type=template&id=51f631d2&"
import script from "./ShippingAddress.vue?vue&type=script&lang=js&"
export * from "./ShippingAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports